<template>
  <div id="app" :class="{ safari: iOS, invert }">
    <slot name="header"></slot>
    <slot><main class="loading">Loading…</main></slot>
    <slot name="footer"></slot>
    <channels-modal v-if="$store.state.showChannels" />
  </div>
</template>

<script>
import ChannelsModal from '../components/ChannelsModal.vue'

export default {
  name: 'default',
  components: { ChannelsModal },
  computed: {
    iOS() {
      var isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/)
      var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      return isSafari && isiOS
    },
    invert() {
      return this.$route.meta.invert
    },
  },
}
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  background: #000;
  color: #fff;
}

#app.safari {
  min-height: 88.5vh;
}

#app.invert {
  background: #fff;
  color: #000;
}
</style>
